<div class="w-full max-w-2xl mx-auto transition-all">
  <div
    [ngClass]="{
      'p-[5px] rounded-2xl bg-gradient-to-r from-sigecom-info via-[#60CEFA] to-sigecom-info':
        showCard,
    }"
  >
    <div
      #container
      class="relative overflow-hidden bg-white"
      [ngClass]="{ 'rounded-xl': showCard }"
    >
      <!-- 🔥 Se estiver girando -->
      <div class="" *ngIf="!showCard; else resultTemplate">
        <div #track class="flex gap-3 py-16">
          <div *ngFor="let item of drawArray">
            <sigecom-card  />
          </div>
        </div>
      </div>

      <!-- 🔥 Resultado -->
      <ng-template #resultTemplate>
        <div class="flex items-center justify-center">
          <div
            class="w-[100%] px-20 py-6 my-3 text-center flex flex-col items-center h-full gap-16"
          >
            <!-- Sigla -->
            <p class="font-bold text-2xl text-sigecom-info">{{ getDisplaySigla() }}</p>

            <!-- Nome completo -->
            <p class="font-black italic text-4xl w-full min-w-[500px] text-sigecom-info h-full">
              {{ getDisplayName() }}
            </p>

            <!-- Logo -->
            <img
              src="assets/card/LogoCBDE.png"
              class="h-[50px] object-contain"
            />
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
